import _G from './SetValueConstant';


_G.defaultLocale = 'en';
_G.locale = 'en';
_G.RTL = false;
_G.fallbacks = true;
_G.noShowInstallPwa = false;

export default _G;
